const hasValue = (value) => value !== null && value !== undefined && String(value).trim() !== '';

const formatDecimal = (value) => {
  if (!hasValue(value)) {
    return '';
  }

  const numeric = Number(value);
  if (!Number.isFinite(numeric)) {
    return String(value).trim();
  }

  return Number.isInteger(numeric) ? String(numeric) : String(Number(numeric.toFixed(3)));
};

const formatRange = (minValue, maxValue, unit) => {
  const minText = formatDecimal(minValue);
  const maxText = formatDecimal(maxValue);

  if (minText && maxText) {
    if (minText === maxText) {
      return `${minText}${unit}`;
    }

    return `${minText}-${maxText}${unit}`;
  }

  if (minText) {
    return `${minText}${unit}`;
  }

  if (maxText) {
    return `${maxText}${unit}`;
  }

  return '';
};

export const formatBoardVoltage = (board) => {
  const supplyRange = formatRange(board?.supply_voltage_min_v, board?.supply_voltage_max_v, 'V');
  const logicRange = formatRange(board?.logic_voltage_min_v, board?.logic_voltage_max_v, 'V');

  if (supplyRange && logicRange && supplyRange !== logicRange) {
    return `${supplyRange} supply, ${logicRange} logic`;
  }

  return supplyRange || logicRange || String(board?.voltage_range || '').trim();
};

export const formatPinVoltage = (pin) => (
  formatRange(pin?.voltage_min_v, pin?.voltage_max_v, 'V')
  || String(pin?.voltage_range || '').trim()
);

export const formatPinCurrent = (pin) => {
  const numericCurrent = formatDecimal(pin?.current_limit_ma);
  if (numericCurrent) {
    return `${numericCurrent}mA`;
  }

  return String(pin?.current_limit || pin?.current_rating || '').trim();
};
